<script setup lang="ts">
type Props = {
  size?: 'normal' | 'large';
}

const props = withDefaults(defineProps<Props>(), {
  size: 'normal',
});
</script>
<template>
  <div
    class="flex items-center justify-center w-[35px] h-[35px] rounded-full"
    style="background: var(--ai-background)"
    :class="{'w-[35px] h-[35px]': props.size === 'normal', 'w-[48px] h-[48px]': props.size === 'large'}"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="props.size === 'normal' ? 18 : 24"
      :height="props.size === 'normal' ? 19 : 26"
      viewBox="0 0 18 19"
      fill="none"
    >
      <g clip-path="url(#clip0_2668_56175)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.5316 2.75444L17.7936 3.17508C18.0688 3.26684 18.0688 3.65619 17.7936 3.74795L16.5316 4.16859C16.4415 4.19865 16.3707 4.26939 16.3407 4.35955L15.92 5.62149C15.8283 5.89675 15.4389 5.89675 15.3471 5.62149L14.9265 4.35955C14.8964 4.26939 14.8257 4.19865 14.7355 4.16859L13.4736 3.74795C13.1983 3.65619 13.1983 3.26684 13.4736 3.17508L14.7355 2.75444C14.8257 2.72438 14.8964 2.65364 14.9265 2.56348L15.3471 1.30154C15.4389 1.02628 15.8283 1.02628 15.92 1.30154L16.3407 2.56348C16.3707 2.65364 16.4415 2.72438 16.5316 2.75444ZM6.77061 2.50283C7.03059 1.7229 8.13376 1.72292 8.39373 2.50283L9.94015 7.14208L14.5794 8.6885C15.3593 8.94847 15.3593 10.0516 14.5794 10.3116L9.94015 11.858L8.39373 16.4973C8.13376 17.2772 7.03058 17.2772 6.77061 16.4973L5.22419 11.858L0.58494 10.3116C-0.194987 10.0516 -0.194973 8.94847 0.58494 8.6885L5.22419 7.14208L6.77061 2.50283ZM7.58217 4.84204L6.55293 7.92977C6.46778 8.18522 6.26733 8.38566 6.01188 8.47081L2.92415 9.50006L6.01188 10.5293C6.26733 10.6145 6.46778 10.8149 6.55293 11.0703L7.58217 14.1581L8.61142 11.0703C8.69657 10.8149 8.89701 10.6145 9.15246 10.5293L12.2402 9.50006L9.15246 8.47081C8.89702 8.38567 8.69657 8.18522 8.61142 7.92977L7.58217 4.84204ZM17.7936 15.2522L16.5316 14.8315C16.4415 14.8015 16.3707 14.7307 16.3407 14.6406L15.92 13.3786C15.8283 13.1034 15.4389 13.1034 15.3471 13.3786L14.9265 14.6406C14.8964 14.7307 14.8257 14.8015 14.7355 14.8315L13.4736 15.2522C13.1983 15.3439 13.1983 15.7333 13.4736 15.825L14.7355 16.2457C14.8257 16.2757 14.8964 16.3465 14.9265 16.4366L15.3471 17.6986C15.4389 17.9738 15.8283 17.9738 15.92 17.6986L16.3407 16.4366C16.3707 16.3465 16.4415 16.2757 16.5316 16.2457L17.7936 15.825C18.0688 15.7333 18.0688 15.3439 17.7936 15.2522Z"
          fill="url(#paint0_linear_2668_56175)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2668_56175"
          x1="0"
          y1="1.09509"
          x2="20.1811"
          y2="4.33994"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FBBF24" />
          <stop offset="0.33" stop-color="#F87171" />
          <stop offset="0.66" stop-color="#A78BFA" />
          <stop offset="1" stop-color="#60A5FA" />
        </linearGradient>
        <clipPath id="clip0_2668_56175">
          <rect
            y="0.5"
            :width="props.size === 'normal' ? 18 : 24"
            :height="props.size === 'normal' ? 18 : 24"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>
